import { MAX_TEXT_LENGTH_FOR_EXPAND } from 'infrastructure/consts/tables';
import { useTranslation } from 'react-i18next';
import useAlert from 'infrastructure/hooks/utils/use-alert';
import useUser from 'utils/useUser';
import TrashDeleteIcon from 'components/atoms/icons/trashIcon';

import s from '../styles.module.scss';

import type { FC } from 'react';

interface Props {
  expandedRecord: any;
  deleteNote: any;
  value: any;
  record: any;
}

const NoteCommentsColumn: FC<Props> = ({
  expandedRecord,
  deleteNote,
  value,
  record,
}) => {
  const { t } = useTranslation();
  const { Alert, showAlert } = useAlert();
  const { userType, isAdmin } = useUser();

  const isValueLongerThenMax = value.length >= MAX_TEXT_LENGTH_FOR_EXPAND;
  const handleDelete = async () => {
    const message = `${t('labels.noteDeleteConfirm')} ${t(
      'labels.noteDeleteConfirmInteractiveTime',
    )}`;
    const alertAnswer = await showAlert({
      title: t('labels.commentDeleteTitle'),
      messageTitle: message,
      successBtnLabel: t('controls.yes'),
      rejectBtnLabel: t('controls.no'),
    });

    if (alertAnswer) {
      await deleteNote({
        guid: record.guid,
        userType,
      });
    }
  };
  return (
    <div
      style={{
        cursor: isValueLongerThenMax ? 'pointer' : 'auto',
        wordBreak: 'break-word',
      }}
    >
      {isAdmin && (
        <div className={s['top-right-actions']}>
          <button
            className={s['delete-button']}
            onClick={handleDelete}
            aria-label="Delete comment"
          >
            <TrashDeleteIcon />
          </button>
        </div>
      )}
      {Alert}
      <div data-cy="clinic-notes-note" className={s.note}>
        {isValueLongerThenMax
          ? `${value.slice(0, MAX_TEXT_LENGTH_FOR_EXPAND)} ...`
          : value}
      </div>
      {isValueLongerThenMax && (
        <div className={s['show-more']}>
          {expandedRecord?.expanded && expandedRecord?.guid === record.guid
            ? t('controls.showLess')
            : t('controls.showMore')}
        </div>
      )}
    </div>
  );
};

export default NoteCommentsColumn;
